export const CALC = {
  langToggle: "lang-toggle",
  themeToggle: "theme-toggle",
  brand: "brand-logo",
  heroCta: "hero-cta",
  serviceCard: (id) => `service-card-${id}`,
  expPill: (id) => `experience-pill-${id}`,
  cxPill: (id) => `complexity-pill-${id}`,
  unitSelect: "unit-select",
  quantityInput: "quantity-input",
  revisionsInput: "revisions-input",
  rushToggle: "rush-toggle",
  descriptionInput: "description-input",
  priceCard: "live-price-breakdown-card",
  minValue: "price-min",
  avgValue: "price-avg",
  maxValue: "price-max",
  aiCard: "ai-pricing-suggestion-card",
  aiButton: "ai-suggest-button",
  aiApply: "ai-apply-button",
  copyBtn: "copy-summary-button",
  printBtn: "print-quote-button",
  saveBtn: "save-quote-button",
  whatsappBtn: "whatsapp-share-button",
  clientInput: "client-name-input",
  ratesModal: "editable-market-rates-modal",
  ratesOpenBtn: "rates-open-button",
  ratesResetBtn: "rates-reset-button",
  ratesSaveBtn: "rates-save-button",
};
